namespace $.$$ {
	$mol_style_define( $shm_hitalama_guide, {
		List: { width: '22rem', minWidth: 0, flex: { basis: '22rem', grow: 0, shrink: 0 } },
	})
}
